/** Коды модулей платформы. Новый модуль добавляется в этот список. */
export const MODULE_IDS = ['pricing', 'dco', 'sco', 'planner', 'marker'] as const;

export type ModuleId = (typeof MODULE_IDS)[number];

export function isModuleId(value: unknown): value is ModuleId {
  return typeof value === 'string' && (MODULE_IDS as readonly string[]).includes(value);
}

/** Брендинг тенанта — JSON с бэка, редактируется в админке (§8) */
export interface TenantBranding {
  logoUrl: string;
  logoCollapsedUrl?: string;
  /** HEX; из него генерируется вся палитра */
  primaryColor: string;
  colorScheme?: 'light' | 'dark' | 'auto';
  radius?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  fontFamily?: string;
  // v2: layout-конфиг (порядок/видимость виджетов)
}

export interface TenantInfo {
  id: string;
  /** Слаг из поддомена: nak.buildex.com → 'nak' (может содержать точки: 'bi.group') */
  slug: string;
  name: string;
}

export type FeatureFlags = Record<string, boolean>;

/** Ответ GET /api/tenant/config — единый конфиг тенанта */
export interface TenantConfig {
  tenant: TenantInfo;
  /** Оплаченные (активные) модули; только они грузятся браузером */
  modules: ModuleId[];
  branding: TenantBranding;
  featureFlags: FeatureFlags;
}
